// extracted by mini-css-extract-plugin
export default {"loading":"vCoinRecord_loading__z-CV-","h5Wrap":"vCoinRecord_h5Wrap__ufzeX"};